module.exports = __webpack_public_path__ + "media/images/business/img-mv-785948f317790e2f08768e6d9ee3a55a.png";